import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum } from "components/table/lib/sort"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { PercentTenantRevenue_s } from "components/line-items/line-items-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

import portfolioService from "data/portfolio"

const DefaultPortfolio = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<number[]|null>(props?.rowData[props?.field] || []);
  const [portfolios, setPortfolios] = useState<object[]>([]);
  const [allPortfolios, setAllPortfolios] = useState<object[]>([]);
  const [showSelected, setShowSelected] = useState<boolean>(props?.rowData[props?.field]?.length > 0);

  useEffect(() => {
    if (!props['rowData'][props.field]) {
      setData([]);
      setShowSelected(false)
    }
  }, [props['rowData']])

  useEffect(() => {
    const portfolioSubscription = portfolioService.stream().subscribe(data => {
      if (data.value.length > 0){
        setPortfolios(data.value);
        setAllPortfolios(data.value);
        filterPortfolios(data.value)
      }
    })

    portfolioService.fetchPortfolios()

    return function cleanup() {
      portfolioSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    filterPortfolios(portfolios)
  }, [showSelected, data])

  function filterPortfolios(portfolios):void {
    if (showSelected && data){
      setPortfolios(portfolios?.filter(portfolio => data.includes(portfolio['portfolioid'])));
    } else {
      setPortfolios(allPortfolios);
    }
  }

  const updateData = (val:number[]) => {
    setData(val);
    props.persist(val, 'defaultportfolios', props.rowData);
    if (val.length === 0){
      setShowSelected(false)
    }
  }

  const attrs = (field) => field_attrs('defaultportfolios')(field)(props.rowData, props)

  // if (showSelected && data){
  //   setPortfolios(portfolios?.filter(portfolio => data.includes(portfolio['portfolioid'])));
  // }

  function selectAll():void {
    data?.length === portfolios.length ? updateData([]) : updateData(portfolios.map(portfolio => portfolio['portfolioid']))
  }

  if (sortDirty){
    sortAsc ? portfolios.sort((a, b) => alphanum(a['code'], b['code'])) : portfolios.sort((a, b) => alphanum(b['code'], a['code']))
  }
  
  return (
    <PercentTenantRevenue_s>
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Portfolios</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: data ? data.length === portfolios.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": data}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={(val)=>updateData(val)}
            options={portfolios.map(portfolio => { return {label: `${portfolio['code']}`, value: portfolio['portfolioid']}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </PercentTenantRevenue_s>
  )
}

export default DefaultPortfolio
